// extracted by mini-css-extract-plugin
export default {"home__form":"Footer_home__form__Bb-0k","home__header":"Footer_home__header__wXyU2","home__button":"Footer_home__button__phc4X"};